export enum RiskPrivacyStatusTypes {
  Public = 0,
  Confidential = 1,
}
